import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { MetricsCompartments, metricsStorageKey } from '..';

export class GroupMetricsListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.GroupAdminRolesResolved)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(metricsStorageKey)
    private readonly cache: DataCache<MetricsCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('groupMetrics');
        } else {
          this.cache.reset('groupMetrics');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}

export class TeamMetricsListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.TeamAdminRolesResolved)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(metricsStorageKey)
    private readonly cache: DataCache<MetricsCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('teamMetrics');
        } else {
          this.cache.reset('teamMetrics');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
